<mat-card class="horiz-float-bar-card" *ngIf="isVisible()">
  <div class="horiz-float-bar-div">
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.OUTLINE_MAP'| translate" matTooltipPosition="below" matTooltipShowDelay="2000" (click)="onOutlineMapClick()">
        <mat-icon [ngClass]="isOutlineMap() ? 'svg-icon-selected' : 'svg-icon'" svgIcon="map-outline"></mat-icon>
      </button>
    </div>
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.SATELLITE'| translate" matTooltipPosition="below" matTooltipShowDelay="2000" (click)="onSatMapClick()">
        <mat-icon [ngClass]="isSatMap() ? 'svg-icon-selected' : 'svg-icon'" svgIcon="map-sat"></mat-icon>
      </button>
    </div>
    <div class="horiz-float-bar-button-div">
        <button mat-icon-button [matTooltip]="'MAP.SATELLITE'| translate" matTooltipPosition="below" matTooltipShowDelay="2000" (click)="onOfflineMapClick()">
          <mat-icon [ngClass]="isOfflineMap() ? 'svg-icon-selected' : 'svg-icon'" svgIcon="map-sat"></mat-icon>
        </button>
      </div>
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.3D_VIEW'| translate" matTooltipPosition="below" matTooltipShowDelay="2000" [disabled]="is3DMapDisabled()"
        (click)="on3DMapClick()">
        <mat-icon [ngClass]="is3DMapDisabled() ? 'svg-icon-disabled' : 'svg-icon'" svgIcon="map-3d"></mat-icon>
      </button>
    </div>
  </div>
</mat-card>
